import "./style.css";

export default class CookieBanner {
  static selector = ".cookie-banner";

  constructor(block) {
    this.block = block;

    const cookiePolicy = JSON.parse(
      window.localStorage.getItem("cookiePolicy")
    );

    if (!cookiePolicy) {
      this.showCookieBanner();
      this.accept = block.querySelector(".cookie-banner__accept");
      this.accept.addEventListener("click", this.onAcceptClicked);

      this.close = block.querySelector(".cookie-banner__close");
      this.close.addEventListener("click", this.onCloseClicked);
    }
  }

  showCookieBanner = () => {
    this.block.style.display = "block";
  };

  onCloseClicked = () => {
    this.block.addEventListener("transitionend", this.hideCookieBanner);
    this.block.style.opacity = "0";
    this.block.style.pointerEvents = "none";
  };

  onAcceptClicked = () => {
    window.localStorage.setItem("cookiePolicy", JSON.stringify(true));
    this.block.addEventListener("transitionend", this.hideCookieBanner);
    this.block.style.opacity = "0";
    this.block.style.pointerEvents = "none";
  };

  hideCookieBanner = () => {
    this.block.style.display = "none";
    this.block.removeEventListener("transitionend", this.hideCookieBanner);
  };
}
